var _rect, _path, _circle, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 400,
    rx: 40,
    ry: 40,
    width: 150,
    height: 150,
    stroke: "#5958cd",
    fill: "#5958cd"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    begin: "0s",
    dur: "35s",
    type: "rotate",
    from: "0 1450 550",
    to: "360 1450 550",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 100 350 A 150 150 0 1 1 400 350 Q400 370 380 370 L 250 370 L 120 370 Q100 370 100 350",
    fill: "#5958cd"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M 800 -200 L 800 -300 L 800 -200",
    dur: "20s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    begin: "0s",
    dur: "30s",
    type: "rotate",
    values: "0 210 530 ; -30 210 530 ; 0 210 530",
    keyTimes: "0 ; 0.5 ; 1",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 180,
    stroke: "#5958cd",
    fill: "#5958cd"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M 0 0 L 40 20 Z",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 165 580 L 270 580 Q275 578 270 570 L 223 483 Q220 480 217 483 L 165 570 Q160 578 165 580",
    fill: "#5958cd"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    begin: "0s",
    dur: "35s",
    type: "rotate",
    from: "0 210 530",
    to: "360 210 530",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 350 A 40 40 0 1 1 180 350 L 180 430 A 40 40 0 1 1 100 430 Z",
    fill: "#5958cd"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M 140 390 L 180 360 L 140 390",
    dur: "20s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    begin: "0s",
    dur: "30s",
    type: "rotate",
    values: "0 140 390; -60 140 390; 0 140 390",
    keyTimes: "0 ; 0.5 ; 1",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 600,
    rx: 40,
    ry: 40,
    width: 100,
    height: 100,
    stroke: "#5958cd",
    fill: "#5958cd"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    begin: "0s",
    dur: "35s",
    type: "rotate",
    from: "-30 550 750",
    to: "330 550 750",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login_bg.39ec11bf1ec6bc4a4365eeed5b50871d.svg";
export { ForwardRef as ReactComponent };